import {
  Stethoscope, Pill, ShoppingCart, Boxes, ClipboardList, Building2,
} from 'lucide-react';

export function detectRole(userId) {
  const id = (userId || '').trim().toLowerCase();
  if (!id) return null;
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(id)) return 'email';
  if (/^\+?\d[\d\s-]{8,}$/.test(id)) return 'email';
  if (id.startsWith('pharmacystores')) return 'pharmacystores';
  if (id.startsWith('storesadmin')) return 'storesadmin';
  if (id.startsWith('pharmacy')) return 'pharmacy';
  if (id.startsWith('purchase')) return 'purchase';
  return 'doctor';
}

/** Default chrome for IITH / single-tenant campus portal (email → OTP). */
export const HOSPITAL_PORTAL_CHROME = {
  title: 'Sign in',
  subtitle: 'Staff & campus portal · email OTP',
  icon: Building2,
  idLabel: 'Email address',
  idPlaceholder: 'e.g. fic.hospital@iith.ac.in',
  btn: 'bg-[#0C2744] hover:bg-[#071B34]',
};

export const ROLE_CHROME = {
  doctor: {
    title: 'Doctor portal',
    subtitle: 'Clinical consultation workspace',
    icon: Stethoscope,
    idLabel: 'Doctor ID',
    idPlaceholder: 'Enter your Doctor ID',
    btn: 'bg-[#0C2744] hover:bg-[#071B34]',
  },
  email: { ...HOSPITAL_PORTAL_CHROME },
  pharmacy: {
    title: 'Pharmacy portal',
    subtitle: 'Dispensing & fulfilment',
    icon: Pill,
    idLabel: 'Pharmacy User ID',
    idPlaceholder: 'e.g. pharmacy01',
    btn: 'bg-emerald-700 hover:bg-emerald-800',
  },
  purchase: {
    title: 'Purchase portal',
    subtitle: 'Procurement & vendors',
    icon: ShoppingCart,
    idLabel: 'Purchase User ID',
    idPlaceholder: 'e.g. purchase01',
    btn: 'bg-[#0C2744] hover:bg-[#071B34]',
  },
  pharmacystores: {
    title: 'Pharmacy stores',
    subtitle: 'Stockroom indents',
    icon: Boxes,
    idLabel: 'Pharmacy Stores User ID',
    idPlaceholder: 'e.g. pharmacystores01',
    btn: 'bg-amber-700 hover:bg-amber-800',
  },
  storesadmin: {
    title: 'Stores admin',
    subtitle: 'PR review & purchase orders',
    icon: ClipboardList,
    idLabel: 'Stores Admin User ID',
    idPlaceholder: 'e.g. storesadmin01',
    btn: 'bg-[#0C2744] hover:bg-[#071B34]',
  },
};
